import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=29dc93fa&scoped=true"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=29dc93fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc93fa",
  null
  
)

export default component.exports